// src/utils/staff.js
const STAFF_KEY = "mudoStaff";
const ACTIVE_KEY = "mudoActiveStaffId";
const TARGETS_KEY = "mudoStaffTargets";

export function getAllStaff() {
  try {
    const arr = JSON.parse(localStorage.getItem(STAFF_KEY) || "[]");
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}

export function getActiveStaffId() {
  try { return localStorage.getItem(ACTIVE_KEY) || null; } catch { return null; }
}

export function setActiveStaffId(id) {
  try { localStorage.setItem(ACTIVE_KEY, String(id)); } catch {}
}

export function getStaffTargets() {
  try {
    const obj = JSON.parse(localStorage.getItem(TARGETS_KEY) || "{}");
    return obj && typeof obj === "object" ? obj : {};
  } catch {
    return {};
  }
}

export function setStaffTargets(next) {
  try { localStorage.setItem(TARGETS_KEY, JSON.stringify(next || {})); } catch {}
}

export function setStaffTarget(id, minutesPerWeek) {
  const all = getStaffTargets();
  all[String(id)] = Number(minutesPerWeek) || 0;
  setStaffTargets(all);
}

export function getStaffById(id) {
  return getAllStaff().find((s) => String(s.id) === String(id)) || null;
}
